import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=b60eaf68&"
import script from "./ruleDialog.vue?vue&type=script&lang=js&"
export * from "./ruleDialog.vue?vue&type=script&lang=js&"
import style0 from "./ruleDialog.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports